import React from 'react';
import clsx from 'clsx';

/* eslint-disable-next-line */
export interface IPanelFooterProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export const PanelFooter: React.FC<IPanelFooterProps> = (props): JSX.Element => {
    const {
        className,
        ...rest
    } = props;

    return (
        <div
            className={clsx('oms-panel__footer', className)}
            {...rest}
        />
    );
};
